import { cn } from "@/lib/utils";
import * as React from "react";

const SheetHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div
    className={cn("flex flex-col gap-2 text-center", className)}
    {...props}
  />
);

SheetHeader.displayName = "SheetHeader";

export default SheetHeader;
